//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue         from 'vue';
import Component   from 'vue-class-component';
import Bugsnag     from '@bugsnag/js'
import EState      from '@/classes/State.enum';
import FormWrapper from '@/components/FormWrapper';
import MissingNo   from '@/components/MissingNo';

const FORM_ITEMS = [
	{
		key      : 'Category',
		label    : 'Category',
		type     : 'select',
		validate : 'category',
		options  : [
			'Website',
			'Dota 2 Bug',
			'Warcraft 3 Bug',
			'Other',
		],
	},
	{
		key      : 'Email',
		label    : 'Email Address',
		type     : 'email',
		default  : 'eg: someone@email.com',
		validate : 'email address',
	},
	{
		key      : 'Description',
		label    : 'Description',
		type     : 'textarea',
		default  : 'Please describe your issue - the more details you can provide, the better!',
		validate : 'description',
		minimum  : 10,
		maximum  : 1000,
	},
];

@Component({
	metaInfo   : {
		title : 'Report an Issue',
	},
	components : {
		FormWrapper,
		MissingNo,
	},
})
export default class Feature extends Vue {
	// Constants Passthrough
	//--------------------------------------------------------------------------------------------------

	EState     = EState;

	FORM_ITEMS = FORM_ITEMS;

	// Members
	//--------------------------------------------------------------------------------------------------

	state = EState.NONE;

	// Methods
	//--------------------------------------------------------------------------------------------------

	onSubmit (callback, models) {
		const [ category, email, description ] = models;

		this.state = EState.SUBMITTING;
		this.$http
			.put(`/submit/report`, {
				category,
				email,
				description,
			})
			.then(() => this.state = EState.SUBMITTED)
			.catch(err => {
				this.state = EState.FAILED

				Bugsnag.notify(err);
			})
			.finally(callback);
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<section class="g--flowdown g--center-content g--fullscreen">
	<div class="g--stretch">
		<div class="s--navbar-gap" />
	</div>

	<transition name="t--fade" mode="out-in">
		<!--#############################################################################################-->

		<div v-if="state === EState.SUBMITTED" key="submitted">
			<h3>Thank You</h3>
			<p>Your report has been sent for review.</p>
		</div>

		<!--#############################################################################################-->

		<MissingNo v-else-if="state === EState.FAILED" key="failed">
			Error Occurred
		</MissingNo>

		<!--#############################################################################################-->

		<FormWrapper
			v-else
			key        = "form"
			title      = "Report an Issue"
			:items     = "FORM_ITEMS"
			:actions   = "[{ label: 'Submit', action: onSubmit, check: true }]"
			:agreement = "true"
		/>

		<!--#############################################################################################-->
	</transition>

	<div class="g--stretch">
		<div class="s--footer-gap" />
	</div>
</section>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
</style>
